"use strict"

import React, { useContext, useEffect, useState } from "react"
import { Button, Tab, Nav } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import { showModal } from "../../shared_components/utils"
import SetHeightLoaderFrame from "../widgets/SetHeightLoaderFrame"
import { displayRef } from "../widgets/utils"
import { addNewObject } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import { withSourceRegistrationConfig } from "../../config/SourceRegistrationConfigProvider"

import AddSourceModal from "./modals/AddSourceModal"
import ManageDCSTablesTable from "./ManageDCSTablesTable"
import SourceTagsTable from "./SourceTagsTable"
import { AppSettingConfigContext } from "../../config/AppSettingsConfigProvider"

function SourceRegistration({
  translation_ids,
  type,
  getTablesLoad,
  hideDCSTables,
  getSources,
  getSourceTags,
  getSourceInfo,
  getSourceLoading,
  sourceTypes,
  dcs_tables,
}) {
  const app_config = useContext(AppSettingConfigContext)
  const [permissions, setPermissions] = useState([])

  useEffect(() => {
    if (app_config.config.user && app_config.config.user.permissions) {
      setPermissions(app_config.config.user.permissions)
    }
  }, [app_config.config.user])

  const resources = {
    sources: getSources(type),
    getSourceInfo: () => getSourceInfo(type),
    type_id: sourceTypes[type],
    loading: getSourceLoading(type),
    tags: getSourceTags(type),
  }
  const [sources, setSources] = useState([])
  const [sourceFocus, setSourceFocus] = useState({})

  useEffect(() => {
    resources.getSourceInfo()
  }, [])

  useEffect(() => {
    if (!sourceFocus.name && resources.tags.length > 0) {
      setSourceFocus(resources.tags[0])
    } else if (resources.tags.filter((tag) => tag.name === sourceFocus.name).length > 0) {
      setSourceFocus(resources.tags.filter((tag) => tag.name === sourceFocus.name)[0])
    }
    setSources(resources.tags.sort((a, b) => a.name.localeCompare(b.name)))
  }, [resources.tags])

  const [sourceModal, setSourceModal] = useState(false)
  const [newSourceWarn, setNewSourceWarn] = useState(false)

  const generateNewSource = (data, loaderRef) => {
    addNewObject("/warehouse/sources/", { ...data, type_id: resources.type_id })
      .then((_) => {
        setSourceModal(false)
        setNewSourceWarn(false)
        resources.getSourceInfo()
      })
      .catch((err) => {
        displayRef(loaderRef, false)
        console.error(err)
        logToServer(err)
        setNewSourceWarn(err)
      })
  }

  return (
    <>
      <Tab.Container defaultActiveKey={`tab0`} style={{ margin: "20px 0px" }}>
        <div className={"row"} style={{ margin: "0", marginTop: "15px" }}>
          <div className={"col-xxl-2 col-xl-3"} style={{ padding: "0px" }}>
            <Nav variant={"pills"} className={"flex-column"} style={{ marginBottom: "15px" }}>
              {sources.map((source, idx) => {
                const sourceTables = dcs_tables
                  .filter((t) => source.id === t?.source?.id)
                  .filter((t) => t.unregistered_cols_num > 0 && t.active)
                return (
                  <Nav.Link
                    className={"side_nav_pills"}
                    eventKey={`tab${idx}`}
                    onClick={(e) => {
                      e.preventDefault()
                      if (sourceFocus && sourceFocus.name && sourceFocus.name !== source.name) {
                        setSourceFocus(source)
                      }
                    }}
                    key={`${source.name}_Nav_Option`}
                  >
                    {sourceTables.length > 0 && (
                      <>
                        <span className={"fa fa-flag text-danger"} />
                        &nbsp;
                      </>
                    )}
                    {source.name}
                  </Nav.Link>
                )
              })}
            </Nav>
            {permissions.includes("add_source") && (
              <Button
                variant={"outline-primary"}
                onClick={(e) => {
                  e.preventDefault()
                  showModal(setSourceModal)
                }}
                disabled={!resources.type_id || resources.loading}
                style={{ width: "100%", whiteSpace: "normal", marginBottom: "50px" }}
              >
                <span className={"fa fa-plus-circle"} />
                &nbsp;&nbsp;&nbsp;
                <FormattedMessage
                  id={translation_ids["register_new"]}
                  defaultMessage={"Register New Source"}
                />
              </Button>
            )}
          </div>
          <div className={"col-xxl-10 col-xl-9"}>
            {!resources.loading &&
              sources.length > 0 &&
              sources.map((source, idx) => {
                return (
                  <Tab.Content key={`${source.name}_Tab`} className={"zeroHeight"}>
                    <Tab.Pane eventKey={`tab${idx}`} transition={false}>
                      <div className={"card"}>
                        <div className={"card-header"} style={{ display: "flex" }}>
                          <div style={{ marginRight: "auto" }}>
                            <h4>
                              <FormattedMessage id={translation_ids["type"]} defaultMessage={"Name"} />
                              :&nbsp;&nbsp;
                              {source.name}
                            </h4>
                            <h6>
                              <FormattedMessage id={"general.description"} defaultMessage={"Description"} />
                              :&nbsp;&nbsp;
                              {source.description}
                            </h6>
                          </div>
                          <div style={{ marginLeft: "auto" }}>
                            <Button
                              variant={"outline-primary"}
                              onClick={() => {
                                getTablesLoad(type)
                              }}
                              style={{ float: "left" }}
                            >
                              <i className="fa fa-refresh" style={{ marginRight: "2px" }} />
                              &nbsp;
                              <FormattedMessage id={"general.refresh"} defaultMessage={"refresh"} />
                            </Button>
                          </div>
                        </div>
                        <div className={"card-body"}>
                          <SourceTagsTable source={source} permissions={permissions} resources={resources} />
                          {!hideDCSTables && (
                            <ManageDCSTablesTable source={source} type={type} permissions={permissions} />
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                )
              })}
            {resources.loading && (
              <Tab.Content key={"LoadingTab"}>
                <SetHeightLoaderFrame height={500} />
              </Tab.Content>
            )}
          </div>
        </div>
      </Tab.Container>
      {sourceModal && (
        <AddSourceModal
          show={sourceModal}
          onHide={() => setSourceModal(false)}
          warning={newSourceWarn}
          clearWarning={() => setNewSourceWarn(false)}
          type={type}
          page_translation_id={translation_ids["register_new"]}
          page_glyph={"fa-check-square-o"}
          submitData={generateNewSource}
        />
      )}
    </>
  )
}

export default withSourceRegistrationConfig(SourceRegistration)
